import { createApp } from 'vue'
import { reactive } from 'vue';
import App from './App.vue'
import router from './router'

import PrimeVue from 'primevue/config'

import AutoComplete from 'primevue/autocomplete';
// import Accordion from 'primevue/accordion';
// import AccordionTab from 'primevue/accordiontab';
import Badge from 'primevue/badge';
import Button from 'primevue/button';
// import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
// import Carousel from 'primevue/carousel';
// // // import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
// import Chips from 'primevue/chips';
// import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
// import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
// import DataView from 'primevue/dataview';
// import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
// import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
// import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
// // // import FullCalendar from 'primevue/fullcalendar';
// import InlineMessage from 'primevue/inlinemessage';
// import Inplace from 'primevue/inplace';
// import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
// import Galleria from 'primevue/galleria';
// import Listbox from 'primevue/listbox';
// import MegaMenu from 'primevue/megamenu';
// import Menu from 'primevue/menu';
// import Menubar from 'primevue/menubar';
// import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
// import OrderList from 'primevue/orderlist';
// import OrganizationChart from 'primevue/organizationchart';
// import OverlayPanel from 'primevue/overlaypanel';
// import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
// import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
// import PickList from 'primevue/picklist';
// import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner';
// import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
// import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
// import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
// import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tag from 'primevue/tag';
// import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
// import Tree from 'primevue/tree';
// import TreeTable from 'primevue/treetable';
// import TriStateCheckbox from 'primevue/tristatecheckbox';

import 'primevue/resources/themes/saga-blue/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'                           //icons

import 'primeflex/primeflex.css';
//import 'prismjs/themes/prism-coy.css';
//import '@fullcalendar/core/main.min.css';
//import '@fullcalendar/daygrid/main.min.css';
//import '@fullcalendar/timegrid/main.min.css';
//import './assets/layout/layout.scss';
//import './assets/layout/flags/flags.css';

const app = createApp(App)

app.config.globalProperties.$appState = reactive({ inputStyle: 'outlined' });
app.config.globalProperties.$primevue = reactive({ ripple: true });

import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh';
(() => {

  const Emitter = require('tiny-emitter');
  const emitter = new Emitter();
  app.config.globalProperties.$emitter = emitter;

  const instance = axios.create({
    baseURL: '/api',
    timeout: 15000,
  })

  const refresh = axios.create({
    baseURL: '/api',
    timeout: 15000,
  })

  var accessToken = undefined

  emitter.on('logged-in', (tokens) => {
    localStorage.setItem("authenticated", "true")
    accessToken = tokens.access
  })
  emitter.on('logged-out', () => {
    accessToken = undefined
    localStorage.removeItem("authenticated")
  })

  const version = process.env.VUE_APP_VERSION

  instance.interceptors.request.use(
    request => {
      if (accessToken) {
        request.headers['Authorization'] = `Bearer ${accessToken}`
      }
      request.headers['Accept-Version'] = version
      return request;
    },
    error => Promise.reject(error)
  );

  refresh.interceptors.request.use(
    request => {
      request.headers['Accept-Version'] = version
      return request;
    },
    error => Promise.reject(error)
  );

  // Function that will be called to refresh authorization
  const refreshAuthLogic = failedRequest => refresh.put('/authenticate').then(tokenRefreshResponse => {
    localStorage.setItem('authenticated', "true");
    accessToken = tokenRefreshResponse.data.access
    failedRequest.response.config.headers['Authorization'] = `Bearer ${accessToken}`;
    return Promise.resolve();
  }).catch(error => {
    emitter.emit('logged-out')
    return Promise.reject(error);
  });

  // Instantiate the interceptor (you can chain it as it returns the axios instance)
  createAuthRefreshInterceptor(instance, refreshAuthLogic);

  instance.interceptors.response.use(
    response => response,
    async error => {
      if (error.response.status === 401) {
        return new Promise(() => {
          emitter.emit('logged-out')
        })
      } else if (error.response.status === 426) {
        location.reload()
      }
      return Promise.reject(error);
    }
  );

  app.config.globalProperties.$http = instance;

})()

app.config.globalProperties.$message = {
  message: (summary, message) => {
    this.$toast.add({
      severity: "info",
      summary: summary,
      detail: message,
      life: 2300
    });
  },
  error: (summary, message) => {
    this.$toast.add({
      severity: "error",
      summary: summary,
      detail: message,
      life: 2300
    });
  },
}



const _utils = () => {
  return {
    currency(f, prec) {
      if (!prec || typeof prec != 'number' || prec < 0) {
        prec = 2;
      }
      var v = this.value(f);
      if (v && typeof v === 'number') {
        return v.toFixed(prec).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      }
      return null;
    },
    value(f) {
      if (isNaN(f)) {
        return 0;
      }
      if ((typeof f) == "string") {
        return Number(f);
      }
      return f;
    },
  }
};

app.config.globalProperties.$utils = _utils();

Date.prototype.toJSON = function () {
  var date = new Date(this.toDateString());
  var day = date.getDate();
  var month = date.getMonth() + 1;
  if (day < 10) {
    day = "0" + day;
  }
  if (month < 10) {
    month = "0" + month;
  }
  return date.getFullYear() + "-" + month + "-" + day + 'T00:00:00.000Z';
}

app.use(router)
app.use(PrimeVue, {
  ripple: true,
  locale: {
    startsWith: 'започва с',
    contains: 'съдържа',
    notContains: 'не съдържа',
    endsWith: 'завършва с',
    equals: 'равно на',
    notEquals: 'не е равно на',
    noFilter: 'не е приложен филтър',
    lt: 'по-малко от',
    lte: 'по-малко или равно на',
    gt: 'по-голямо от',
    gte: 'по-голямо или равно на',
    dateIs: 'Датата е',
    dateIsNot: 'Датата не е',
    dateBefore: 'Датата е преди',
    dateAfter: 'Датата е след',
    clear: 'Изчисти',
    apply: 'Приложи',
    matchAll: 'Match All',
    matchAny: 'Match Any',
    addRule: 'Add Rule',
    removeRule: 'Remove Rule',
    accept: 'Да',
    reject: 'Не',
    choose: 'Избери',
    upload: 'Качи',
    cancel: 'Откажи',
    dayNames: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
    dayNamesShort: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    dayNamesMin: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    monthNames: ["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],
    monthNamesShort: ["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],
//    monthNamesShort: ["Ян", "Фев", "Март", "Апр", "Май", "Юни","Юли", "Авг", "Септ", "Окт", "Ноем", "Дек"],
    today: 'Днес',
    weekHeader: 'Седмица',
    firstDayOfWeek: 1,
    dateFormat: 'dd.mm.yy',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    passwordPrompt: 'Въведете парола',
    emptyFilterMessage: 'Няма намерени резултати',
    emptyMessage: 'Няма налични опции'
  }
})
app.use(ToastService)

// app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);
// // app.directive('code', CodeHighlight);

// app.component('Accordion', Accordion);
// app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
// app.component('Breadcrumb', Breadcrumb);
app.component('Badge', Badge);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
// app.component('Carousel', Carousel);
// // // app.component('Chart', Chart);
app.component('Checkbox', Checkbox);
// app.component('Chips', Chips);
// app.component('ColorPicker', ColorPicker);
app.component('Column', Column);
// app.component('ContextMenu', ContextMenu);
app.component('DataTable', DataTable);
// app.component('DataView', DataView);
// app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('Dialog', Dialog);
// app.component('Divider', Divider);
app.component('Dropdown', Dropdown);
// app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
// // // app.component('FullCalendar', FullCalendar);
// app.component('InlineMessage', InlineMessage);
// app.component('Inplace', Inplace);
// app.component('InputMask', InputMask);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
// app.component('Galleria', Galleria);
// app.component('Listbox', Listbox);
// app.component('MegaMenu', MegaMenu);
// app.component('Menu', Menu);
// app.component('Menubar', Menubar);
// app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
// app.component('OrderList', OrderList);
// app.component('OrganizationChart', OrganizationChart);
// app.component('OverlayPanel', OverlayPanel);
// app.component('Paginator', Paginator);
app.component('Panel', Panel);
// app.component('PanelMenu', PanelMenu);
app.component('Password', Password);
// app.component('PickList', PickList);
// app.component('ProgressBar', ProgressBar);
app.component('ProgressSpinner', ProgressSpinner);
app.component('RadioButton', RadioButton);
// app.component('Rating', Rating);
app.component('SelectButton', SelectButton);
// app.component('Slider', Slider);
app.component('Sidebar', Sidebar);
app.component('SplitButton', SplitButton);
// app.component('Steps', Steps);
app.component('TabMenu', TabMenu);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Tag', Tag);
app.component('Textarea', Textarea);
// app.component('TieredMenu', TieredMenu);
app.component('Toast', Toast);
app.component('Toolbar', Toolbar);
app.component('ToggleButton', ToggleButton);
// app.component('Tree', Tree);
// app.component('TreeTable', TreeTable);
// app.component('TriStateCheckbox', TriStateCheckbox);



import ButtonsApplyCancel from './components/common/ButtonsApplyCancel'
app.component('ButtonsApplyCancel', ButtonsApplyCancel)

import EntityManager from './components/common/EntityManager'
app.component('EntityManager', EntityManager)

import DeliveryItem from './components/DeliveryItem'
app.component('DeliveryItem', DeliveryItem)

import Delivery from './components/Delivery'
app.component('Delivery', Delivery)

import DeliveryImporter from './components/DeliveryImporter'
app.component('DeliveryImporter', DeliveryImporter)

import SaleItem from './components/SaleItem'
app.component('SaleItem', SaleItem)

import Sale from './components/Sale'
app.component('Sale', Sale)

import Sales from './components/Sales'
app.component('Sales', Sales)

import ConsumptionItem from './components/ConsumptionItem'
app.component('ConsumptionItem', ConsumptionItem)

import Consumption from './components/Consumption'
app.component('Consumption', Consumption)

import Consumptions from './components/Consumptions'
app.component('Consumptions', Consumptions)

import Chooser from './components/Chooser'
app.component('Chooser', Chooser)

import ContragentsChooser from './components/ContragentsChooser'
app.component('ContragentsChooser', ContragentsChooser)

import Contragents from './components/Contragents'
app.component('Contragents', Contragents)

import ProductsChooser from './components/ProductsChooser'
app.component('ProductsChooser', ProductsChooser)

import ProductsImporter from './components/ProductsImporter'
app.component('ProductsImporter', ProductsImporter)

import Products from './components/Products'
app.component('Products', Products)

import Report from './components/common/Report'
app.component('Report', Report)

import StockTurnover from './components/StockTurnover'
app.component('StockTurnover', StockTurnover)

import StockSales from './components/StockSales'
app.component('StockSales', StockSales)

import InvoiceCreator from './components/InvoiceCreator'
app.component('InvoiceCreator', InvoiceCreator)

import LoadingDialog from './components/common/LoadingDialog'
app.component('LoadingDialog', LoadingDialog)

import Login from './components/Login'
app.component('Login', Login)

app.mount('#app')
